<!--
 * @Author: xiaokun
 * @Date: 2020-02-27 16:04:42
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-07-10 15:35:13
 * @Description: 活码-企业活码tab
 -->
<template>
  <div class="compony-code-tab">
    <!-- 搜索栏 -->
    <div class="search-line">
      <mk-select
        v-model="codeStatus.value"
        class="select-common"
        :placeholder="codeStatus.defaultText"
        width="200"
        clearable
        @change="checkoutStatus"
      >
        <mk-option
          v-for="item in codeStatus.list"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></mk-option>
      </mk-select>
      <!-- @blur="searchCode" -->
      <mk-input
        v-model="codeName"
        class="mr-16"
        width="240"
        placeholder="请输入活码名称"
        clearable
        @clear="searchCode"
        @keyup.enter.native="searchCode"
      >
        <div
          slot="suffix"
          class="el-input__icon"
        >
          <i
            class="el-icon-search"
            @click="searchCode"
          />
        </div>
      </mk-input>
      <mk-button-biz
        type="primary"
        icon="el-icon-search"
        @click="searchCode"
      >
        搜索
      </mk-button-biz>
      <mk-button-biz @click="reset">
        重置
      </mk-button-biz>
      <!-- 新增企业活码 -->
      <mk-button-biz
        type="primary"
        class="add-code"
        @click="addEditCode"
      >
        <mk-iconfont icon-class="xinzeng" />
        <span class="add-code-text">新增企业活码</span>
      </mk-button-biz>
    </div>
    <!-- 企业活码表格 -->
    <div class="code-table">
      <mk-table
        v-if="tableMaxHeight"
        :max-height="tableMaxHeight"
        :data="tableData"
        style="width: 100%;"
      >
        <!-- 活码名称 -->
        <mk-table-column
          prop="name"
          label="活码名称"
          min-width="240"
          class="code-name"
          show-overflow-tooltip
        ></mk-table-column>
        <!-- 备注 -->
        <mk-table-column
          prop="remark"
          label="备注"
          min-width="240"
          show-overflow-tooltip
        ></mk-table-column>
        <!-- 活码缩略图 -->
        <mk-table-column
          prop="codeLinkImg"
          label="活码缩略图"
          min-width="150"
        >
          <template v-slot="scope">
            <mk-popover
              placement="bottom"
              width="120"
              trigger="hover"
            >
              <img
                v-show="scope.row.codeLinkImg"
                style="width:150px;"
                :src="scope.row.codeLinkImg"
                alt="活码"
              />
              <mk-iconfont
                slot="reference"
                icon-class="erweima"
              />
            </mk-popover>
          </template>
        </mk-table-column>
        <!-- 活码使用状态 -->
        <mk-table-column
          prop="state"
          label="使用状态"
          min-width="100"
        >
          <template v-slot="scope">
            <span v-if="scope.row.isEnable">已启用</span>
            <span v-else>未启用</span>
          </template>
        </mk-table-column>
        <!-- 销售二维码数量 -->
        <mk-table-column
          prop="sales"
          label="销售二维码数量"
          min-width="120"
        >
          <template v-slot="scope">
            <span class="executor-detail">
              <span class="sale-num">{{ scope.row.saleNum }}</span>
              <!-- 存有离职销售/停用的销售二维码时 -->
              <mk-popover
                v-if="scope.row.isShowSaleInfoContent"
                trigger="hover"
                placement="right"
                popper-class="sale-confirm"
                :content="scope.row.saleInfoContent"
              >
                <mk-iconfont
                  slot="reference"
                  icon-class="jingshi"
                />
              </mk-popover>
            </span>
          </template>
        </mk-table-column>
        <!-- 操作 -->
        <mk-table-column
          prop="handle"
          label="操作"
          width="180"
          fixed="right"
        >
          <template v-slot="scope">
            <!-- state === 0 未启用，展示启用按钮 -->
            <span
              v-if="!scope.row.isEnable"
              class="options-btn"
              @click="startUse(scope.row)"
            >
              启用
            </span>
            <span
              v-else
              class="options-btn"
              @click="stopUse(scope.row)"
            >
              停用
            </span>
            <!-- 下载 -->
            <span
              class="options-btn"
            >
              <!-- 下载 -->
              <a
                :href="scope.row.codeLinkImg"
                :download="scope.row.name"
              >下载</a>
            </span>
            <!-- 编辑 -->
            <span
              class="options-btn"
              @click="addEditCode(true,scope.row._id)"
            >
              编辑
            </span>
            <mk-popover
              :ref="`popover-${scope.$index}`"
              placement="top"
              trigger="click"
              popper-class="qrcode-delete-confirm"
              reference
            >
              <div>
                <div class="mention-text">
                  <mk-iconfont icon-class="guanbihuojingshihuocuowu" />确定要删除此活码吗？
                </div>
                <div class="button-delete-button">
                  <mk-button-biz
                    width="50px"
                    height="24px"
                    @click="deleteQrcode(scope.row),$refs[`popover-${scope.$index}`].$children[0].doClose()"
                  >
                    确定
                  </mk-button-biz>
                  <mk-button-biz
                    width="50px"
                    height="24px"
                    type="primary"
                    @click="$refs[`popover-${scope.$index}`].$children[0].doClose()"
                  >
                    取消
                  </mk-button-biz>
                </div>
              </div>
              <span
                slot="reference"
                class="options-btn"
              >
                删除
              </span>
            </mk-popover>
          </template>
        </mk-table-column>
      </mk-table>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <mk-pagination
        :current-page.sync="page"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
      ></mk-pagination>
    </div>
  </div>
</template>
<script>
import { WeChatLoginApi } from '../../../../api/jingtui/services'
export default {
  name: 'ComponyCodeTab',
  components: {},
  props: {},
  data () {
    return {
      tableMaxHeight: 0,
      codeName: '',
      total: 0,
      page: 1,
      // 活码状态
      codeStatus: {
        value: '',
        defaultText: '使用状态',
        list: [
          {
            value: true,
            label: '已启用'
          },
          {
            value: false,
            label: '未启用'
          }
        ]
      },
      // 企业活码列表
      tableData: [],
      // 搜索参数
      searchParams: {},
      pageSize: 10

    }
  },
  watch: {},
  created () {
    this.getComponyCodeList()
  },

  mounted () {
    this.$nextTick(() => {
      this.util.handleTableMaxHeight('.code-table', this)
    })
  },
  methods: {
    // 新增/编辑 活码跳转
    addEditCode (isEdit, _id) {
      let query = {}
      // isEdit = true 时 携带id 跳转至编辑页
      if (isEdit) {
        query.codeId = _id
      }
      this.$router.push({
        path: '/marketing-content/activity-code/add-edit-code',
        query: query
      })
    },
    // 获取企业活码列表
    async getComponyCodeList (searchParams = {}) {
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        keyword: this.codeName,
        isEnable: this.codeStatus.value,

        ...searchParams
      }

      if (!this.codeName) {
        delete params['keyword']
      }
      if (this.codeStatus.value === '') {
        delete params['isEnable']
      }

      let res = await MKMATERIALSVC.QrCodeApi.qrcodeListGet(params)
      if (res.success) {
        this.total = res.data.total
        res.data.data.forEach(async (item) => {
          // 销售数量
          item.saleNum = item.saleIDs.length || 0
          /** 销售异常提示
           * userInfo.status 为 stop时，表示该销售已离职
           * userInfo.enable_wx_qr_code 为false时 表示该销售二维码已停用
           */
          item.userInfo.forEach((sales) => {
            if (sales.status === 'stop') {
              item.saleInfoContent = '该活码中已有销售离职'
              item.isShowSaleInfoContent = true
            }
            if (!sales.enable_wx_qr_code) {
              item.saleInfoContent = '该活码中已有销售二维码停用'
              item.isShowSaleInfoContent = true
            }
          })
          // 活码缩略图处理，需自己拼接url
          const { qrcodeUrl } = this.util.createH5Url(item, 'qrcode', this.$projectScene, true)
          if (qrcodeUrl) {
            item.codeLinkImg = await this.$createQrcode(qrcodeUrl)
          }
        })
        this.$nextTick(() => {
          this.tableData = res.data.data
        })
      }
    },
    // 切换启用状态
    checkoutStatus () {
      this.searchCode()
    },
    // 搜索
    searchCode () {
      this.searchParams = {
        keyword: this.codeName,
        isEnable: this.codeStatus.value
      }
      if (!this.codeName) {
        delete this.searchParams['keyword']
      }
      if (this.codeStatus.value === '') {
        delete this.searchParams['isEnable']
      }
      // 重置为第一页
      this.page = 1
      this.getComponyCodeList(this.searchParams)
    },
    // 重置操作
    reset () {
      this.codeStatus.value = ''
      this.codeName = ''
      this.page = 1
      this.getComponyCodeList()
    },
    // 启用操作
    startUse (data) {
      // 停用成功变为启用状态，当前状态为停用
      this.upDataCode(data, false)
    },
    // 停用操作
    stopUse (data) {
      // 启用成功变为停用状态，当前状态为启用
      this.upDataCode(data, true)
    },
    // 删除操作
    async deleteQrcode (data) {
      data.deletePop = false
      let params = {
        codeID: data._id
      }
      let res = await MKMATERIALSVC.QrCodeApi.qrcodeDelete(params)
      if (res.success) {
        this.$message.success('删除成功')
        this.getComponyCodeList()
      } else {
        this.$message.error('删除失败')
      }
    },
    // 分页
    handleCurrentChange (e) {
      this.page = e
      this.getComponyCodeList()
    },
    // 更新活码接口，停用 启用时需要全量更新，只改变启用停用参数状态
    async upDataCode (data, isEnable) {
      // isEnable 为当前状态
      let params = data
      if (isEnable) {
      // 启用变停用 isEnable 由true变false
        params.isEnable = false
      } else {
        // 停用变启用 isEnable 由false变true
        params.isEnable = true
      }
      let res = await MKMATERIALSVC.QrCodeApi.qrcodePut(params)
      if (res.success) {
        if (isEnable) {
          params.isEnable = false
          this.$message.success('停用成功')
        } else {
          params.isEnable = true
          this.$message.success('启用成功')
        }
        this.searchCode()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.compony-code-tab {
  display: flex;
  flex-direction: column;
  width: calc(100% - 40px);
  height: calc(100% - 20px);
  margin: 10px auto 0;

  & /deep/ .el-input__inner {
    padding-right: 50px;
  }

  & /deep/ .el-input__suffix {
    .el-input__clear {
      position: absolute;
      top: 0;
      left: -25px;
    }
  }

  a {
    text-decoration: none;
    color: #009cff;
  }

  .search-line {
    // display: flex;
    position: relative;

    .select-common {
      margin-right: 8px;
    }

    .mr-16 {
      margin-right: 16px;
    }

    .add-code {
      position: absolute;
      right: 0;
      padding: 0 13px !important;

      .icon-mk-xinzeng {
        color: #fff;
        font-size: 13px;
      }

      .add-code-text {
        padding-left: 8px;
      }
    }
  }

  .code-table {
    // margin-top: 24px;
    margin-top: 10px;
    flex: 1;

    /deep/ .el-table__row {
      font-size: 13px;

      .el-button--text {
        font-size: 13px;
      }
    }

    .qrcode-img {
      width: 30px;
      height: 30px;
    }

    .executor-detail {
      display: flex;

      .sale-num {
        margin-right: 6px;
      }

      .icon-mk-jingshi {
        font-size: 14px;
        color: #ff6b6b;
        margin-right: 8px;
      }
    }

    .options-btn {
      font-size: 13px;
      color: #009cff;
      cursor: pointer;

      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }

  .pagination {
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-end;
  }
}

// 删除浮层
.qrcode-delete-confirm {
  .mention-text {
    font-size: 14px;
    color: #595959;

    .icon-mk-guanbihuojingshihuocuowu {
      font-size: 14px;
      color: #f5222d;
      margin-right: 8px;
    }
  }

  .button-delete-button {
    margin-top: 12px;
    text-align: right;
  }
}
</style>
